import tribunalAPI from "api/tribunalAPi";

export interface NumeroRegistrado {
  idtblPersonasAutorizadas: number;
  aceptaWhatsapp: string;
  telefonoWhatsapp: string;
  muestraMensajeWhatsapp: string;
}

export interface PINResponse {
  status: string;
  totalCount: number;
  pin: number;
}

export interface ParamsGuardarNumero {
  aceptaWhats: string;
  numTelefono: string;
  idPersonaAutorizada: string;
}

export const getNumeroRegistrado = async (idPersonaAutorizada: string): Promise<NumeroRegistrado> => {
  const url = `whatsapp/obtener/numero`;
  const responseData = (await tribunalAPI.get(url, {
    params: {
      idPersonaAutorizada
    }
  })).data;
  return responseData;
}

export const getEnviarPIN = async (params: { numTelefono: string }): Promise<PINResponse> => {
  const url = `whatsapp/enviar/pin`;
  const responseData = (await tribunalAPI.get(url, {
    params
  })).data;
  return responseData;
}

export const getGuardarNumero = async (params: ParamsGuardarNumero): Promise<any> => {
  const url = `whatsapp/enviar/registro`;
  const responseData = (await tribunalAPI.get(url, { params })).data.data;
  return responseData;
};